import { render, staticRenderFns } from "./GermplasmDownload.vue?vue&type=template&id=2331d58a&"
import script from "./GermplasmDownload.vue?vue&type=script&lang=js&"
export * from "./GermplasmDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports